/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Gopay_Return_MissingInputs */

const cs_billing_gopay_return_missing = /** @type {(inputs: Billing_Gopay_Return_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí id platby — vraťte se do fakturace.`)
};

const en_billing_gopay_return_missing = /** @type {(inputs: Billing_Gopay_Return_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing payment id — return to billing.`)
};

/**
* | output |
* | --- |
* | "Missing payment id — return to billing." |
*
* @param {Billing_Gopay_Return_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_gopay_return_missing = /** @type {((inputs?: Billing_Gopay_Return_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Gopay_Return_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_gopay_return_missing(inputs)
	return cs_billing_gopay_return_missing(inputs)
});